import {SERVICE_ROUTE_UPLOAD} from '@/env';
import {MultipartProperties} from "@/types/MultipartProperties";

export const UPLOAD_BASE_URL_V2 = `${SERVICE_ROUTE_UPLOAD}/v2/upload/multiple`;
export const UPLOAD_TASK_URL_V2 = `${SERVICE_ROUTE_UPLOAD}/v2/task`;
export const UPLOAD_INFO_URL_V2 = `${SERVICE_ROUTE_UPLOAD}/v2/info`;

type AccessToken = {
    accessToken: string;
}

type TaskId = {
    taskId: string;
}

export type AccessTokenOrTaskId = AccessToken | TaskId;

const addQueryParam = (baseUrl: string, accessTokenOrTaskId: AccessTokenOrTaskId): string => {
    return 'taskId' in accessTokenOrTaskId ? `${baseUrl}?taskId=${accessTokenOrTaskId.taskId}`
        : `${baseUrl}?access_token=${accessTokenOrTaskId.accessToken}`;
}

export const getMaxRequestSize = (): Promise<MultipartProperties> => {
    return fetch(`${UPLOAD_INFO_URL_V2}/max-request-size`)
        .then((response) => response.json());
}

export const getMaxFileSize = (): Promise<MultipartProperties> => {
    return fetch(`${UPLOAD_INFO_URL_V2}/max-file-size`)
        .then((response) => response.json());
}

export const uploadMultipleDocuments = (accessTokenOrTaskId: AccessTokenOrTaskId, documentType: string, files: File[]): Promise<Response> => {
    const url = `${addQueryParam(`${UPLOAD_BASE_URL_V2}`, accessTokenOrTaskId)}&documentType=${documentType}`;
    const data = new FormData();
    for (let file of files)
        data.append('files', file);
    data.append('documentType', documentType);
    return fetch(url, {
        method: 'POST',
        body: data
    });
}

export const ocr = (accessTokenOrTaskId: AccessTokenOrTaskId): Promise<Response> => {
    return fetch(addQueryParam(`${UPLOAD_BASE_URL_V2}/ocr`, accessTokenOrTaskId), {
        method: 'POST'
    });
};

export const getTask = (accessTokenOrTaskId: AccessTokenOrTaskId): Promise<Response> => {
    return fetch(addQueryParam(`${UPLOAD_BASE_URL_V2}/task`, accessTokenOrTaskId));
};
